import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postArchiveDataEndpoint } from '../../../common/endpoints';

export const getArchiveData = createApi(postArchiveDataEndpoint, 'GET');

const GetArchive = createSlice({
  name: 'GetArchive',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getArchiveData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArchiveData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getArchiveData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetArchive.reducer;